import { 
  CategoryConfig, 
  CATEGORY_TYPES, 
  CATEGORY_FEATURES 
} from './categoryTypes';

// Category configurations
export const CATEGORY_CONFIGS = {
  [CATEGORY_TYPES.WEDDING]: new CategoryConfig({
    id: 'wedding-ceremonies',
    type: CATEGORY_TYPES.WEDDING,
    name: 'wedding',
    displayName: 'Wedding Ceremonies',
    description: 'Sacred wedding rituals and ceremonies for your special day',
    icon: '💒',
    image: '/images/categories/wedding.jpg',
    features: [
      CATEGORY_FEATURES.BOOKING,
      CATEGORY_FEATURES.CUSTOMIZATION,
      CATEGORY_FEATURES.CONSULTATION,
      CATEGORY_FEATURES.DOCUMENTATION
    ],
    metadata: {
      dataSource: 'WEDDING_SERVICES',
      filterKey: 'wedding',
      pageConfigKey: 'wedding',
      priority: 1,
      popularityScore: 95
    },
    customization: {
      primaryColor: '#dc2626',
      secondaryColor: '#fecaca',
      theme: 'elegant',
      showAdvancedFilters: true,
      enablePriceComparison: true,
      showReviews: true
    }
  }),

  [CATEGORY_TYPES.HOME_POOJA]: new CategoryConfig({
    id: 'home-poojas',
    type: CATEGORY_TYPES.HOME_POOJA,
    name: 'homePooja',
    displayName: 'Home Poojas',
    description: 'Traditional home worship and blessing ceremonies',
    icon: '🏠',
    image: '/images/categories/home-pooja.jpg',
    features: [
      CATEGORY_FEATURES.BOOKING,
      CATEGORY_FEATURES.INSTANT_BOOKING,
      CATEGORY_FEATURES.CONSULTATION
    ],
    metadata: {
      dataSource: 'HOME_POOJA_SERVICES',
      filterKey: 'homePooja',
      pageConfigKey: 'homePooja',
      priority: 2,
      popularityScore: 88
    },
    customization: {
      primaryColor: '#ea580c',
      secondaryColor: '#fed7aa',
      theme: 'warm',
      showAdvancedFilters: false,
      enablePriceComparison: true,
      showReviews: true
    }
  }),

  [CATEGORY_TYPES.FESTIVAL]: new CategoryConfig({
    id: 'festival-celebrations',
    type: CATEGORY_TYPES.FESTIVAL,
    name: 'festival',
    displayName: 'Festival Celebrations',
    description: 'Festive rituals and celebrations for special occasions',
    icon: '🎉',
    image: '/images/categories/festival.jpg',
    features: [
      CATEGORY_FEATURES.BOOKING,
      CATEGORY_FEATURES.CUSTOMIZATION,
      CATEGORY_FEATURES.LIVE_STREAMING
    ],
    metadata: {
      dataSource: 'FESTIVAL_SERVICES',
      filterKey: 'festival',
      pageConfigKey: 'festival',
      priority: 3,
      popularityScore: 82
    },
    customization: {
      primaryColor: '#7c2d12',
      secondaryColor: '#fef3c7',
      theme: 'festive',
      showAdvancedFilters: true,
      enablePriceComparison: false,
      showReviews: true
    }
  }),

  [CATEGORY_TYPES.LIFE_EVENTS]: new CategoryConfig({
    id: 'life-events',
    type: CATEGORY_TYPES.LIFE_EVENTS,
    name: 'lifeEvents',
    displayName: 'Life Events',
    description: 'Sacred ceremonies for important life milestones',
    icon: '🌟',
    image: '/images/categories/life-events.jpg',
    features: [
      CATEGORY_FEATURES.BOOKING,
      CATEGORY_FEATURES.CONSULTATION,
      CATEGORY_FEATURES.DOCUMENTATION
    ],
    metadata: {
      dataSource: 'LIFE_EVENTS_SERVICES',
      filterKey: 'lifeEvents',
      pageConfigKey: 'lifeEvents',
      priority: 4,
      popularityScore: 75
    },
    customization: {
      primaryColor: '#059669',
      secondaryColor: '#d1fae5',
      theme: 'serene',
      showAdvancedFilters: true,
      enablePriceComparison: true,
      showReviews: true
    }
  }),

  [CATEGORY_TYPES.SPIRITUAL]: new CategoryConfig({
    id: 'spiritual-services',
    type: CATEGORY_TYPES.SPIRITUAL,
    name: 'spiritual',
    displayName: 'Spiritual Services',
    description: 'Spiritual guidance and meditation services',
    icon: '🕉️',
    image: '/images/categories/spiritual.jpg',
    features: [
      CATEGORY_FEATURES.BOOKING,
      CATEGORY_FEATURES.CONSULTATION,
      CATEGORY_FEATURES.LIVE_STREAMING
    ],
    metadata: {
      dataSource: 'SPIRITUAL_SERVICES',
      filterKey: 'spiritual',
      pageConfigKey: 'spiritual',
      priority: 5,
      popularityScore: 70
    },
    customization: {
      primaryColor: '#7c3aed',
      secondaryColor: '#e9d5ff',
      theme: 'mystical',
      showAdvancedFilters: false,
      enablePriceComparison: false,
      showReviews: true
    }
  }),

  [CATEGORY_TYPES.SPECIAL_OCCASIONS]: new CategoryConfig({
    id: 'special-occasions',
    type: CATEGORY_TYPES.SPECIAL_OCCASIONS,
    name: 'specialOccasions',
    displayName: 'Special Occasions',
    description: 'Customized ceremonies for unique celebrations',
    icon: '🎊',
    image: '/images/categories/special-occasions.jpg',
    features: [
      CATEGORY_FEATURES.BOOKING,
      CATEGORY_FEATURES.CUSTOMIZATION,
      CATEGORY_FEATURES.CONSULTATION
    ],
    metadata: {
      dataSource: 'SPECIAL_OCCASIONS_SERVICES',
      filterKey: 'specialOccasions',
      pageConfigKey: 'specialOccasions',
      priority: 6,
      popularityScore: 65
    },
    customization: {
      primaryColor: '#db2777',
      secondaryColor: '#fce7f3',
      theme: 'celebration',
      showAdvancedFilters: true,
      enablePriceComparison: true,
      showReviews: true
    }
  })
};

// Utility functions
export const getCategoryConfig = (categoryType) => {
  return CATEGORY_CONFIGS[categoryType];
};

export const getAllCategoryConfigs = () => {
  return Object.values(CATEGORY_CONFIGS);
};

export const getActiveCategoryConfigs = () => {
  return getAllCategoryConfigs().filter(config => config.isActive());
};

export const getCategoryConfigById = (categoryId) => {
  return getAllCategoryConfigs().find(config => config.id === categoryId);
};

export const getCategoriesByFeature = (feature) => {
  return getAllCategoryConfigs().filter(config => config.hasFeature(feature));
};

export const getCategoriesSortedByPriority = () => {
  return getAllCategoryConfigs().sort((a, b) => 
    a.getMetadata('priority') - b.getMetadata('priority')
  );
};

export const getCategoriesSortedByPopularity = () => {
  return getAllCategoryConfigs().sort((a, b) => 
    b.getMetadata('popularityScore') - a.getMetadata('popularityScore')
  );
};
